import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { DataService } from '../../../../shared/dataservice.service';
import { DsControlAuxIP, SaveEventType, SaveStatusObj, SOModule, UserType, ValidationItem, ValidationSummary } from '../../../../shared/misc-classes';
import { ValidationDialog } from '../../../../dialogs/validation-dialog/validation-dialog';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

@Component({
  selector: 'ds-control-aux',
  templateUrl: './ds-control-aux.component.html',
  styleUrls: ['./ds-control-aux.component.css']
})
export class DsControlAuxComponent implements OnInit, OnChanges {
  
    @Input() dsControlAuxObj: DsControlAuxIP;
    @Input() soLockObtained:boolean;
    @Input() accessLevel: Array<UserType>;
    @Output() updateDatasheet: EventEmitter<SaveStatusObj> = new EventEmitter();
    
    disableForm: boolean = false;
    inputDisableMessage: string = 'This form is not yet enabled';
    readonlyAccess : boolean = false;
    Hvr:any = {};
    hasAccessEE: boolean = false;
    hasAccessME: boolean = false;
    hasAccessPM: boolean = false;
    lockFields: boolean = false; // After HOM lock
  
    constructor(public _dataService: DataService, public dialog: MatDialog) { }
  
    ngOnInit(): void {
    }
    ngOnChanges(): void {
       this.disableForm = true;
      if(this.soLockObtained == false){
        this.inputDisableMessage = "You can't Edit";
      }
      else if (this.accessLevel.includes(this._dataService.userType) == false) {
      this.inputDisableMessage = "You don't have EDIT ACCESS.";
    }
      else {
        this.disableForm = false;
        // this.checkUserEnabled();
      }
      if(this._dataService.hasReadOnlyAccess){
        this.readonlyAccess = true;
      }
      this.hasAccessEE = this._dataService.userType === (UserType.ELECTRICAL_ENGINEERING) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
      this.hasAccessME = this._dataService.userType === (UserType.MECHANICAL_ENGINEERING) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
      this.hasAccessPM = this._dataService.userType === (UserType.PROJECT_MANAGEMENT) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
      if (!this.dsControlAuxObj.parentSORef.isDatasheetSubOrderEnabled) {
        this.lockFields = false;
      }
      else {
        this.lockFields = true;
      }
  
    }

  sectionNoteChangePM(_event: any) {
    this.dsControlAuxObj.sectionNotePM = _event.target.value;
  }
  sectionNoteChangeEE(_event: any) {
    this.dsControlAuxObj.sectionNoteEE = _event.target.value;
  }
  sectionNoteChangeME(_event: any) {
    this.dsControlAuxObj.sectionNoteME = _event.target.value;
  }

  saveDS(_submitToNextSection:boolean){
      if(this.updateDatasheet){
        this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing, 
            (_submitToNextSection == true ? SaveEventType.Submit_To_Next:SaveEventType.Save_Data)));
      }
    }
    reloadData(){
      if(this.updateDatasheet){
        this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing, SaveEventType.Reload_Data));
      }
    }

  showSoValidation() {
    let _validList: Array<ValidationItem> = [];

    if (this.hasAccessEE) {
      _validList.push(
        new ValidationItem("Closing and Tripping Circuit", !!this.dsControlAuxObj.closeTripCirc, " required to save Datasheet."),
        new ValidationItem("Additional Trip Coil Circuit", !!this.dsControlAuxObj.addTripCoilCirc, " required to save Datasheet."),
        new ValidationItem("Spring Charging Motor", !!this.dsControlAuxObj.springChargingMotor, " required to save Datasheet."),
        new ValidationItem("Annunciation Circuit", !!this.dsControlAuxObj.annunCircuit, " required to save Datasheet."),
        new ValidationItem("Metering", !!this.dsControlAuxObj.meteringConAux, " required to save Datasheet."),
        new ValidationItem("Space Heater", !!this.dsControlAuxObj.spaceHeater, " required to save Datasheet."),
        new ValidationItem("EE Note", !!this.dsControlAuxObj.sectionNoteEE, " required to save Datasheet.")
      );
      if (this.dsControlAuxObj.isAddTripCoilSpecReqApplicable) {
        _validList.push(new ValidationItem("Add. Trip Coil Detail", !!this.dsControlAuxObj.addTripCoilCircDetail, " required to save Datasheet."));
      }
    }

    if (this.hasAccessPM) {
      _validList.push(
        new ValidationItem("PM Note", !!this.dsControlAuxObj.sectionNotePM, " required to save Datasheet.")
      );
    }

    if (this.hasAccessME) {
      _validList.push(
        new ValidationItem("ME Note", !!this.dsControlAuxObj.sectionNoteME, " required to save Datasheet.")
      );
    }

    let vSummaryObj: ValidationSummary = new ValidationSummary("Validation Summary.", _validList);
    this.dialog.open(ValidationDialog, { width: '50%', data: vSummaryObj });
  }

  saveSOValidation(): boolean {
    if (this.hasAccessEE) {
      if (!this.dsControlAuxObj.closeTripCirc || !this.dsControlAuxObj.addTripCoilCirc ||
        !this.dsControlAuxObj.springChargingMotor || !this.dsControlAuxObj.annunCircuit ||
        !this.dsControlAuxObj.meteringConAux || !this.dsControlAuxObj.spaceHeater ||
        !this.dsControlAuxObj.sectionNoteEE) {
        return false;
      }
      if (this.dsControlAuxObj.isAddTripCoilSpecReqApplicable) {
        if (!this.dsControlAuxObj.addTripCoilCircDetail) return false;
      }
    }
    if (this.hasAccessPM) {
      if (!this.dsControlAuxObj.sectionNotePM) return false;
    }
    if (this.hasAccessME) {
      if (!this.dsControlAuxObj.sectionNoteME) return false;
    }
    return true;
  }

}

